import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Header } from 'semantic-ui-react';
import _isString from 'lodash/isString';
import { getHourToDisplay, getPopUpLabelForDaily } from './HoursOfOperation.utils';
import HoursOfOperationDaily from './HoursOfOperationDaily';
import HoursOfOperationLabeled from './HoursOfOperationLabeled';
import HoursOfOperationModal from './HoursOfOperationModal';
import HoursOfOperationDailyWithPopup from './HoursOfOperationWithPopup';
import { groupByDay, groupByDayAndTime, groupByLabel, groupByDayLabel, NO_LABEL, HOURS_LABELS, getHourLabel, allDayHoursAreUndefined, getHourGroups } from './utils';
import { HourOfOperationPropType } from '../../services/proptypes';
import IconElement from '../IconElement';
import './HoursOfOperation.css';
var HoursOfOperation = /*#__PURE__*/function (_React$Component) {
  _inherits(HoursOfOperation, _React$Component);
  var _super = _createSuper(HoursOfOperation);
  function HoursOfOperation(props) {
    var _this;
    _classCallCheck(this, HoursOfOperation);
    _this = _super.call(this, props);
    _this.createLabelForDays = _this.createLabelForDays.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(HoursOfOperation, [{
    key: "getLabeledComponentAndTodaysHour",
    value: function getLabeledComponentAndTodaysHour() {
      var _this$props = this.props,
        firstGroupLevel = _this$props.firstGroupLevel,
        hours = _this$props.hours,
        displayOption = _this$props.displayOption,
        startWithToday = _this$props.startWithToday,
        timezone = _this$props.timezone,
        orientation = _this$props.orientation,
        animated = _this$props.animated,
        celled = _this$props.celled,
        inlineHours = _this$props.inlineHours,
        startDay = _this$props.startDay;
      var isHorizontal = orientation === 'horizontal';
      var labelGroups = null;
      var todaysHourOfOperation = null;
      if (firstGroupLevel === 'label') {
        var _groupByLabel = groupByLabel(hours, this.createLabelForDays, displayOption, startWithToday, timezone, startDay);
        var _groupByLabel2 = _slicedToArray(_groupByLabel, 2);
        labelGroups = _groupByLabel2[0];
        todaysHourOfOperation = _groupByLabel2[1];
      } else {
        var _groupByDayLabel = groupByDayLabel(hours, this.createLabelForDays, displayOption, startWithToday, timezone, startDay);
        var _groupByDayLabel2 = _slicedToArray(_groupByDayLabel, 2);
        labelGroups = _groupByDayLabel2[0];
        todaysHourOfOperation = _groupByDayLabel2[1];
      }
      var component = /*#__PURE__*/React.createElement(HoursOfOperationLabeled, {
        data: labelGroups,
        isHorizontal: isHorizontal,
        animated: animated,
        celled: celled,
        inlineHours: inlineHours
      });
      return [component, todaysHourOfOperation];
    }
  }, {
    key: "getDailyComponentAndTodaysHour",
    value: function getDailyComponentAndTodaysHour() {
      var _this$props2 = this.props,
        hours = _this$props2.hours,
        displayOption = _this$props2.displayOption,
        startWithToday = _this$props2.startWithToday,
        timezone = _this$props2.timezone,
        orientation = _this$props2.orientation,
        animated = _this$props2.animated,
        celled = _this$props2.celled,
        inlineHours = _this$props2.inlineHours,
        startDay = _this$props2.startDay;
      var isHorizontal = orientation === 'horizontal';
      var groupedHourGroups = displayOption === 'grouped' ? groupByDayAndTime(hours, this.createLabelForDays) : groupByDay(hours, this.createLabelForDays);
      var _getHourGroups = getHourGroups(groupedHourGroups, timezone, startWithToday, startDay),
        _getHourGroups2 = _slicedToArray(_getHourGroups, 2),
        todayFirstInHoursGroup = _getHourGroups2[0],
        hourGroups = _getHourGroups2[1];
      var component = /*#__PURE__*/React.createElement(HoursOfOperationDaily, {
        hourGroups: hourGroups,
        isHorizontal: isHorizontal,
        animated: animated,
        celled: celled,
        inlineHours: inlineHours
      });
      var todaysHourOfOperation = todayFirstInHoursGroup[0];
      return [component, todaysHourOfOperation];
    }
  }, {
    key: "getPopUpLabelForLabeled",
    value: function getPopUpLabelForLabeled(hourDay) {
      var _this$props3 = this.props,
        firstGroupLevel = _this$props3.firstGroupLevel,
        timezone = _this$props3.timezone;
      var label = '';
      var secondaryLabel = '';
      if (firstGroupLevel === 'day') {
        var _getPopUpLabelForDail = getPopUpLabelForDaily(hourDay, timezone);
        var _getPopUpLabelForDail2 = _slicedToArray(_getPopUpLabelForDail, 2);
        label = _getPopUpLabelForDail2[0];
        secondaryLabel = _getPopUpLabelForDail2[1];
      }
      if (firstGroupLevel === 'label') {
        label = hourDay.mainLabel === NO_LABEL ? 'See hours' : hourDay.mainLabel;
        secondaryLabel = getHourToDisplay(hourDay);
      }
      return [label, secondaryLabel];
    }
  }, {
    key: "formatLabel",
    value: function formatLabel(label) {
      var _this$props4 = this.props,
        capitalizeLabels = _this$props4.capitalizeLabels,
        truncateLabels = _this$props4.truncateLabels;
      var displayedLabel = truncateLabels ? label.slice(0, 3) : label;
      return capitalizeLabels ? displayedLabel.toUpperCase() : displayedLabel;
    }
  }, {
    key: "createLabelForDays",
    value: function createLabelForDays(firstDay) {
      var secondDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var firstLabel = this.formatLabel(HOURS_LABELS[firstDay]);
      if (secondDay !== null) {
        var secondLabel = this.formatLabel(HOURS_LABELS[secondDay]);
        return "".concat(firstLabel, " - ").concat(secondLabel);
      }
      return firstLabel;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        className = _this$props5.className,
        showIcon = _this$props5.showIcon,
        displayOption = _this$props5.displayOption,
        iconAs = _this$props5.iconAs,
        hours = _this$props5.hours,
        timezone = _this$props5.timezone,
        displayOpenClosedStatus = _this$props5.displayOpenClosedStatus,
        header = _this$props5.header,
        subheader = _this$props5.subheader,
        position = _this$props5.position;
      var joinedClassName = ['hours-of-operation', className].join(' ').trim();
      if (allDayHoursAreUndefined(hours)) {
        return null;
      }
      var hoursHaveLabels = hours.some(function (hour) {
        return !!getHourLabel(hour);
      });
      var mainComponent = null;
      var todaysHourOfOperation = null;
      var mainPopupLabel = null;
      var secondaryPopupLabel = null;
      if (hoursHaveLabels) {
        var _this$getLabeledCompo = this.getLabeledComponentAndTodaysHour();
        var _this$getLabeledCompo2 = _slicedToArray(_this$getLabeledCompo, 2);
        mainComponent = _this$getLabeledCompo2[0];
        todaysHourOfOperation = _this$getLabeledCompo2[1];
        var _this$getPopUpLabelFo = this.getPopUpLabelForLabeled(todaysHourOfOperation);
        var _this$getPopUpLabelFo2 = _slicedToArray(_this$getPopUpLabelFo, 2);
        mainPopupLabel = _this$getPopUpLabelFo2[0];
        secondaryPopupLabel = _this$getPopUpLabelFo2[1];
      } else {
        var _this$getDailyCompone = this.getDailyComponentAndTodaysHour();
        var _this$getDailyCompone2 = _slicedToArray(_this$getDailyCompone, 2);
        mainComponent = _this$getDailyCompone2[0];
        todaysHourOfOperation = _this$getDailyCompone2[1];
        var _getPopUpLabelForDail3 = getPopUpLabelForDaily(todaysHourOfOperation, timezone);
        var _getPopUpLabelForDail4 = _slicedToArray(_getPopUpLabelForDail3, 2);
        mainPopupLabel = _getPopUpLabelForDail4[0];
        secondaryPopupLabel = _getPopUpLabelForDail4[1];
      }
      if (displayOption === 'dailyWithPopup') {
        return /*#__PURE__*/React.createElement(HoursOfOperationDailyWithPopup, {
          displayOpenClosedStatus: displayOpenClosedStatus,
          timezone: timezone,
          hours: todaysHourOfOperation.hours,
          label: mainPopupLabel,
          secondaryLabel: secondaryPopupLabel,
          position: position,
          header: header
        }, mainComponent);
      }
      var mainComponentWithHeaders = /*#__PURE__*/React.createElement("div", {
        className: joinedClassName
      }, header && (_isString(header) ? /*#__PURE__*/React.createElement(Header, {
        as: "header",
        className: "h2"
      }, header) : header), subheader && (_isString(subheader) ? /*#__PURE__*/React.createElement(Header, {
        as: "header",
        className: "h3"
      }, subheader) : subheader), mainComponent);
      if (displayOption === 'modal') {
        return /*#__PURE__*/React.createElement(HoursOfOperationModal, {
          iconAs: iconAs
        }, mainComponentWithHeaders);
      }
      return showIcon ? /*#__PURE__*/React.createElement(IconElement, {
        iconType: "clock",
        element: mainComponentWithHeaders,
        iconPosition: "top"
      }) : mainComponentWithHeaders;
    }
  }]);
  return HoursOfOperation;
}(React.Component);
export { HoursOfOperation as default };
HoursOfOperation.defaultProps = {
  animated: false,
  capitalizeLabels: false,
  celled: false,
  className: '',
  displayOption: 'daily',
  displayOpenClosedStatus: false,
  startWithToday: false,
  header: '',
  inlineHours: false,
  iconAs: 'icon',
  orientation: 'vertical',
  showIcon: false,
  subheader: '',
  timezone: null,
  truncateLabels: false,
  firstGroupLevel: 'day',
  startDay: 1,
  // Monday
  position: 'bottom left'
};
HoursOfOperation.propOptions = {
  header: ['Hours of Operation', 'Our Hours', '']
};
HoursOfOperation.dataPropsMap = {
  hours: ['business', 'primary_location', 'hours']
};